import Vue from 'vue'
import App from './views/App.vue'
import Antd from 'ant-design-vue';
import VueBus from 'vue-bus'
import VueClipboard from 'vue-clipboard2'
import store from './store'
import router from './router';
import i18n from './i18n/index'
import * as filters from '@/filter/index';
import 'ant-design-vue/dist/antd.css';
import 'flag-icons/css/flag-icons.min.css'
import "./assets/css/commons.scss";
import "./assets/css/home.scss";
import './assets/css/index.scss';
import './assets/css/override.scss';
// 共享 UX 样式层：新功能（战绩榜 / 出租 / 推广中心 等）统一复用这里的 g-* 类
import './assets/css/growth.scss';
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import 'swiper/dist/css/swiper.css'
import "animate.css"
import { initTheme } from '@/utils/theme'

// v2.4.0：链顺序与默认链以后台配置为准（主网在前 + 后台 sort；排名第一 = 新用户默认）。
// 异步进行、失败静默降级到构建期配置，不阻塞首屏渲染。
store.dispatch('initChainConfig')

// 在 Vue 挂载之前先应用主题，避免首屏"白/黑闪烁"（FOUC）
initTheme()

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueBus);
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
